import { ReactElement } from 'react'
import { StructuralPlanningElementFormHeader } from '@structuralPlanningComponents'
import { Stack } from '@mui/material'
import PlanSettingsForm from '@editor/pages/StructuralPlanning/components/PlanSettingsForm'
import { planSettingsElementId } from '@editor/pages/StructuralPlanning/components/PlanSettingsForm/utils'
import { useElementLabel } from '@editorHooks'
import { CollapsibleSettingsBoxSection } from '@editorComponents'
import usePlanViewSelectedElement from '../hooks/usePlanViewSelectedElement'

/**
 * "Bauteil" tab: the part of the Tragwerksplanung sidebar of the element clicked in the plan
 * view that concerns the plan, its settings.
 */
const PlanViewElementTab = (): ReactElement | null => {
  const element = usePlanViewSelectedElement()
  const getLabel = useElementLabel()

  if (!element) return null
  const guid = planSettingsElementId(element)

  return (
    <Stack spacing={1} sx={{ px: 2, py: 1 }} data-cy="plan-view-element-tab">
      <StructuralPlanningElementFormHeader elementGuid={guid} label={getLabel(guid)} />
      <CollapsibleSettingsBoxSection defaultExpanded={true}>
        {/* Keyed by element: a pending auto-save is flushed to its own element on a switch. */}
        <PlanSettingsForm key={guid} element={element} autoSave />
      </CollapsibleSettingsBoxSection>
    </Stack>
  )
}

export default PlanViewElementTab
